import React from 'react'

function WhyTlb() {
  return (

    <>
        <section className='why-techlab' id='whyChoice'>
            <div className='container'>
                <div className='our-value-mission'>
                    <div className='dis-flex'>
                        <div className='our-value'>
                            <div className='number'>
                                <span>01</span>
                            </div>
                            <div className='txt-sec'>
                                <h6>Mission statement</h6>
                                <p className='sm-para'>our mission is to relentlessly pursue excellence by delivering innovative solutions and services that empower our clients, stakeholders, and society. We strive to drive technological advancements that foster growth and contribute to a sustainable future for all.</p>
                            </div>
                        </div>
                        <div className='our-value'>
                           <div className='number'>
                                <span>02</span>
                           </div>
                            <div className='txt-sec'>
                                <h6>Vision statement</h6>
                                <p className='sm-para'>our vision is to shape the future of tech through relentless pursuit of excellence and groundbreaking developments.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='shape-svg2'>
                <div className='svg-4'>
                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect opacity="0.2" x="14.8987" y="-0.599854" width="21.9223" height="21.9223" rx="2" transform="rotate(45 14.8987 -0.599854)" fill="#CFD2D5"/>
                    </svg>
                </div>
                <svg width="80" height="140" viewBox="0 0 129 220" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Group 27399" opacity="0.3">
                    <circle id="Ellipse 2803" opacity="0.2" cx="107.795" cy="125.795" r="93.4767" fill="#FFE8A7"/>
                    <path id="Polygon 1" d="M81.5288 90.3746C82.9804 76.6373 98.7253 69.5873 109.94 77.6533L157.214 111.656C168.48 119.759 166.726 137.026 154.059 142.697L100.666 166.605C88 172.276 73.9514 162.086 75.4097 148.285L81.5288 90.3746Z" fill="#FFE8A7"/>
                    <circle id="Ellipse 2806" cx="4.8545" cy="173.33" r="4.21583" fill="#E55325"/>
                    </g>
                </svg>     
            </div>
           
        </section>
    </>
  )
}

export default WhyTlb